import {
  DialogTitle,
  DialogContent,
  TextField,
  Typography,
  Grid,
  IconButton,
  Divider,
  Box,
} from "@mui/material";
import { Field, Form, Formik } from "formik";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import React, { useState } from "react";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { axiosPrivate } from "../../../../axios/axios";
import { masterAPI } from "../../../Masters/dataConfig";
import { Save, Clear } from "@mui/icons-material";
import { color } from "../../../../StyleData/Config";
import { toast } from "react-toastify";
import { fromUTC, getCurrentInTimeZone, getDateWithOutUTC, toUTC } from "../../../../utils/dateUtil";
import ResponsiveDialog from "../../../../Component/ResponsiveDialog";

const EditMeterDialog = ({ open, onClose, assetId, meterId, editData, meterCode, meterName }) => {
  const [date, setDate] = useState( (getCurrentInTimeZone().dayjsObject).startOf("day"));
  const [loading, setLoading] = useState(false);

  const handleDateChange = (newDate) => {
    setDate(newDate);
  };

  const initialValues = {
    // comments: editData ? editData.comments : "",
    installationDate: date,
    readingValue:  0,
    dateOfReading:  (getCurrentInTimeZone().dayjsObject),
  };

  const onSubmit = async (values) => {
    setLoading(true);
    const createReadingLink = masterAPI.assetMeter.createreading;
    const meterWoCreatLink = masterAPI.PM.generateworkorderbymeterbase;
  
    const dataToSend = [
      {
        assetId,
        meterId,
        installationDate: toUTC(values.installationDate).utcISOString,
        readingValue: values.readingValue,
        dateOfReading: toUTC(values.dateOfReading).utcISOString,
      },
    ];
  
    const dataToSendMeter = {
      assetId,
      meterId,
      currentReading: values.readingValue,
    };
  
    axiosPrivate
      .post(createReadingLink, dataToSend)
      // .then((res) => {
      //   console.log(res.data);
      //   return axiosPrivate.post(meterWoCreatLink, dataToSendMeter);
      // })
      .then((res) => {
        console.log(res.data);
        setLoading(false);
        onClose();
      })
      .catch(e => {
        toast.error("Reading Value is already assigned")
        setLoading(false);
        console.log(e, "Error in API request");
      });
  };
  

  return (
    <ResponsiveDialog open={open} onClose={onClose}>
      <DialogTitle>
        <Box
          sx={{
            display: "flex",
            width: "100%",
            justifyContent: "space-between",
          }}
        >
          Edit Meter - {meterCode} {meterName}
          <Box>
            <IconButton type="submit" form="edit-meter-form">
              <Save sx={{ color: "#2362B4" }} />
            </IconButton>
            <IconButton onClick={onClose}>
              <Clear />
            </IconButton>
          </Box>
        </Box>
      </DialogTitle>
      <Divider />
      <Formik initialValues={initialValues} onSubmit={onSubmit}>
        {({ setFieldValue,values }) => (
          <Form id="edit-meter-form">
            <DialogContent>
              <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                  <Typography
                    sx={{
                      fontWeight: color.labelFontWeight,
                      mb: color.labelmb,
                      fontSize: color.labelFont,
                      color: color.labelColor,
                    }}
                  >
                    Reading Value
                  </Typography>
                  <Field
                    as={TextField}
                    size="small"
                    type="text"
                    name="readingValue"
                    placeholder="Enter Reading"
                    fullWidth
                    sx={{
                      ".MuiInputBase-input": {
                        "&::placeholder": {
                          opacity: 1,
                          color: color.placeholderColor,
                          fontSize: "13px",
                        },
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <Typography
                    sx={{
                      fontWeight: color.labelFontWeight,
                      mb: color.labelmb,
                      fontSize: color.labelFont,
                      color: color.labelColor,
                    }}
                  >
                    Date of Reading
                  </Typography>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      format="DD/MM/YYYY"
                      value={values.dateOfReading} 
                      onChange={(newValue) => {
                        
                        const dateWithoutUTC = getDateWithOutUTC(newValue);
                        handleDateChange(dateWithoutUTC);
                        setFieldValue("dateOfReading", dateWithoutUTC);
                      }}
                      slotProps={{
                        textField: { size: "small", margin: "-8px 0 0 0" },
                      }}
                    />
                  </LocalizationProvider>
                </Grid>
              </Grid>
            </DialogContent>
          </Form>
        )}
      </Formik>
    </ResponsiveDialog>
  );
};

export default EditMeterDialog;
